
const   PROJECT_GET_LIST        = '/api/projects/get-list'
const   PROJECT_SAVE            = '/api/projects/save'
const   PROJECT_UPDATE            = '/api/projects/update'
const   PROJECT_GET              = '/api/projects/get'
const   PROJECT_DELETE              = '/api/projects/delete'


export default {

    getList(axios, condition, success, fail) {
        let query = {
            params: condition
        }
        axios.get(PROJECT_GET_LIST, query)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },

    save(axios, form, success, fail) {
        axios.post(PROJECT_SAVE, form)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },
    update(axios, form, success, fail) {
        axios.post(PROJECT_UPDATE, form)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },
    get(axios, params, success, fail) {
        let query = {
            params: params
        }
        axios.get(PROJECT_GET, query)
            .then((response) => {
                let data = response.data
                success(data)
            })
            .catch((error) => {
                fail(error)
            })
    },
    delete(axios, form, success, fail) {
        axios.post(PROJECT_DELETE, form)
        .then((response) => {
            let dataJson = response.data
            success(dataJson)
        })
        .catch((error) => {
            fail(error)
        })
    },
   
   
   
}